import React, { useEffect, useRef, useState } from "react";
import { IoChevronDown } from "react-icons/io5";
import { Modal3 } from "../../../../components/DIsplay/Modal/Modal3";
import TextInput from "../../../../components/form/TextInput";
import Button1 from "../../../../components/form/Button1";
import { enqueueSnackbar } from "notistack";
import AssignVoid from "../../../../components/order/Void/AssignVoid";
import voidTicketRequest from "../../../../controllers/booking/postTicketing/void/voidTicketRequest";
import Modal1 from "../../../../components/DIsplay/Modal/Modal1";
import denyVoidRequest from "../../../../controllers/booking/postTicketing/void/denyVoidRequest";
import approveVoidTicket from "../../../../controllers/booking/postTicketing/void/approveVoidTicket";
import ManualVoid from "../../../../components/order/Void/ManualVoid";

function VoidConfirmationManageOrder({ data }) {
  const [manageMenu, setManageMenu] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  const [modal, setModal] = useState({
    assign: false,
    accept: false,
    decline: false,
    void: false,
    manual: false,
  });
  const [loading, setLoading] = useState({
    void: false,
    accept: false,
    decline: false,
    autoQuote: false,
    submission: false,
  });
  const [rejectReason, setRejectReason] = useState(data?.rejectReason || "");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        manageMenu &&
        !menuRef.current?.contains(event.target) &&
        !buttonRef.current?.contains(event.target)
      ) {
        setManageMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [manageMenu]);

  const og = {
    ...data,
    flightBooking: [data?.flightBooking],
    flightObj: data?.flightBooking,
    type: "Flight",
  };

  // console.log({ data });

  const menuItems = [
    {
      label: "Assign Request",
      action: () => {
        setModal({ ...modal, assign: true });
      },
      visible: ["Pending", "Approved"].includes(data?.status),
    },
    {
      label: "Approve Request",
      action: () => {
        handleApproveVoid();
      },
      visible: ["Pending"].includes(data?.status),
    },
    {
      label: "Void Ticket",
      action: () => {
        setModal({ ...modal, void: true });
      },
      visible: ["Approved"].includes(data?.status),
    },
    {
      label: "Manual Void",
      action: () => {
        setModal({ ...modal, manual: true });
      },
      visible: ["Approved"].includes(data?.status),
    },
    {
      label: "Decline Request",
      action: () => {
        setModal({ ...modal, decline: true });
      },
      visible: ["Pending", "Approved"].includes(data?.status),
    },
  ].filter((item) => item?.visible);

  // console.log({ data });

  if (!menuItems?.length) return <></>;

  async function handleVoid() {
    setLoading({ ...loading, void: true });
    const res = await voidTicketRequest(data?._id).finally(() =>
      setLoading({ ...loading, void: false })
    );
    if (res.return) {
      enqueueSnackbar("Ticket has been Void.", { variant: "success" });
      setTimeout(() => {
        window.location.reload();
      }, 300);
    } else enqueueSnackbar(res.msg, { variant: "error" });
  }

  async function handleDenyVoid() {
    const reqBody = {
      // ticketQueueId: _id,
      rejectReason,
    };
    setLoading({ ...loading, decline: true });
    const res = await denyVoidRequest(data?._id, reqBody).finally(() =>
      setLoading({ ...loading, decline: false })
    );

    if (res.return) {
      enqueueSnackbar("Void request has been denied.", { variant: "success" });
      setTimeout(() => {
        window.location.reload();
      }, 300);
    } else enqueueSnackbar(res.msg, { variant: "error" });
  }

  async function handleApproveVoid() {
    setLoading({ ...loading, accept: true });
    const res = await approveVoidTicket(data?._id).finally(() =>
      setLoading({ ...loading, accept: false })
    );
    if (res.return) {
      enqueueSnackbar("Request has been approved.", { variant: "success" });
      setTimeout(() => {
        window.location.reload();
      }, 300);
    } else enqueueSnackbar(res.msg, { variant: "error" });
  }

  async function handleVoid() {
    setLoading({ ...loading, void: true });
    const res = await voidTicketRequest(data?._id).finally(() =>
      setLoading({ ...loading, void: false })
    );
    if (res.return) {
      enqueueSnackbar("Ticket has been Void.", { variant: "success" });
      setTimeout(() => {
        window.location.reload();
      }, 300);
    } else enqueueSnackbar(res.msg, { variant: "error" });
  }

  return (
    <div className="relative w-full lg:w-fit">
      <Modal3
        open={modal.manual}
        setOpen={(modalState) => setModal({ ...modal, manual: modalState })}
        title="Manual Void"
      >
        <div className="p-4 max-w-[700px]">
          <ManualVoid callback={() => window.location.reload()} data={og} />
        </div>
      </Modal3>
      <Modal3
        open={modal.assign}
        setOpen={(modalState) => setModal({ ...modal, assign: modalState })}
        title={"Assign Task"}
      >
        <div className="p-4 max-w-[700px]">
          <AssignVoid
            callback={() => window.location.reload()}
            data={og}
            handleVoid={() => handleVoid()}
          />
        </div>
      </Modal3>
      <Modal1
        open={modal.void}
        setOpen={(modalState) => setModal({ ...modal, void: modalState })}
      >
        <div className="card p-4 flex flex-col  gap-4 min-w-[300px]">
          <h5>Are you sure you want to void this ticket?</h5>
          <div className="flex justify-end items-center gap-4">
            <Button1
              variant="outlined"
              className="btn-outlined flex-1"
              onClick={() => setModal({ ...modal, void: false })}
            >
              No, Close
            </Button1>
            <div>
              <Button1 onClick={() => handleVoid()} loading={loading?.void}>
                Yes, Void Ticket
              </Button1>
            </div>
          </div>
        </div>
      </Modal1>
      <Modal1
        open={modal.decline}
        setOpen={(modalState) => setModal({ ...modal, decline: modalState })}
      >
        <div className="card p-4 flex flex-col  gap-4 min-w-[300px]">
          <h5>What's your reson?</h5>
          <TextInput
            label=""
            multiline
            rows={5}
            placeholder={"e.g. Ticket not available"}
            value={rejectReason || ""}
            onChange={(ev) => setRejectReason(ev.target.value)}
          />
          <div className="flex justify-end items-center gap-4">
            <Button1
              variant="outlined"
              className="btn-outlined flex-1"
              onClick={() => setModal({ ...modal, decline: false })}
            >
              Cancel
            </Button1>
            <div>
              <Button1
                onClick={() => handleDenyVoid()}
                loading={loading.decline}
              >
                Continue
              </Button1>
            </div>
          </div>
        </div>
      </Modal1>
      {loading?.accept ? (
        <div className="primaryLoader"></div>
      ) : (
        <button
          ref={buttonRef}
          onClick={() => setManageMenu((prev) => !prev)}
          className="border border-gray-300 h-12 rounded-md bg-gray-100 hover:bg-gray-200 transition-all w-full px-2 lg:px-4 flex items-center justify-center gap-2 text-sm font-semibold"
        >
          <span>Manage order</span>
          <IoChevronDown
            className={`text-base transition-transform mt-[2px] ${
              manageMenu ? "rotate-180" : ""
            }`}
          />
        </button>
      )}

      {manageMenu && (
        <div
          ref={menuRef}
          className="absolute right-0 mt-2 w-44 rounded-md border border-gray-200 bg-white shadow-lg overflow-hidden z-20"
        >
          {menuItems.map((itm, idx) => (
            <button
              key={idx}
              onClick={() => {
                setManageMenu(false);
                itm.action?.();
              }}
              className="w-full text-left px-3 py-2 text-sm hover:bg-gray-50"
            >
              {itm.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default VoidConfirmationManageOrder;
